import { useDrop } from "react-dnd";
import { EDITOR_DND_TYPES } from "../../canvas/dnd/item-types";

/** Shell-level drop target so release outside a block is a drop, not an HTML5 cancel. */
export function useEmailBuilderDragCancelSink() {
  return useDrop(
    () => ({
      accept: [EDITOR_DND_TYPES.PALETTE, EDITOR_DND_TYPES.CANVAS_ITEM],
      drop: (_item, monitor) => {
        if (monitor.didDrop()) {
          return;
        }
      },
    }),
    [],
  )[1];
}
